import { getFileAvatar } from "@/shared/util/file-avatar-utils";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
} from "@/components/ui";
import { Check, X } from "lucide-react";
import { useEffect, useState } from "react";

export interface UploadFilesProps {
  filesToUpload: File[];
  setFilesToUpload: (files: File[]) => void;
  handleUpload: () => void;
  progress: number;
  uploading: boolean;
}

export const UploadFiles = (props: UploadFilesProps) => {
  const [open, setOpen] = useState<boolean>(props.filesToUpload.length > 0);
  const {
    filesToUpload,
    handleUpload,
    setFilesToUpload,
    progress,
    uploading,
  } = props;

  const handleCloseDialog = () => {
    setFilesToUpload([]);
  };

  const removeFile = (index: number) => {
    const local = [...filesToUpload];
    local.splice(index, 1);
    setFilesToUpload(local);
  };

  useEffect(() => {
    setOpen(filesToUpload.length > 0);
  }, [filesToUpload]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && handleCloseDialog()}>
      <DialogContent
        showClose={false}
        className="flex max-h-[90vh] flex-col gap-0 overflow-hidden p-0 sm:max-w-lg"
      >
        <DialogHeader className="shrink-0 flex-row items-center justify-between gap-4 border-b border-[var(--color-mockup-border)] px-6 py-4 dark:border-[var(--color-mockup-border)]">
          <DialogTitle>File da caricare</DialogTitle>
          <div className="flex items-center gap-1">
            <IconButton
              disabled={uploading}
              onClick={handleCloseDialog}
              aria-label="Chiudi"
            >
              <X className="h-4 w-4" />
            </IconButton>
            <IconButton
              disabled={uploading}
              onClick={handleUpload}
              aria-label="Carica"
            >
              <Check className="h-4 w-4" />
            </IconButton>
          </div>
        </DialogHeader>
        {uploading && (
          <div className="h-1 shrink-0 overflow-hidden bg-[var(--color-surface-secondary)] dark:bg-[var(--color-surface-secondary)]">
            <div
              className="h-full bg-primary transition-[width]"
              style={{ width: `${progress}%` }}
            />
          </div>
        )}
        <div className="min-h-0 flex-1 overflow-y-auto px-6 py-3">
          {filesToUpload !== null && filesToUpload.length > 0 ? (
            <List className="divide-y">
              {filesToUpload.map((file, index) => (
                <ListItem key={index} className="flex items-center gap-3 py-2">
                  <ListItemIcon className="shrink-0">
                    {getFileAvatar(file.type)}
                  </ListItemIcon>
                  <ListItemText primary={file.name} className="min-w-0 flex-1 truncate" />
                  <ListItemSecondaryAction>
                    <IconButton
                      onClick={() => removeFile(index)}
                      aria-label="Rimuovi file"
                      disabled={uploading}
                    >
                      <X className="h-4 w-4" />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              ))}
            </List>
          ) : (
            <p className="py-2 text-body text-[var(--color-mockup-text-mid)]">
              Nessun file da caricare.
            </p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default UploadFiles;
